<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* Global styles remain here */
:root {
  --primary-color: #42b983;
  --secondary-color: #f0f0f0;
  --correct-color: #28a745;
  --incorrect-color: #dc3545;
  --text-color: #2c3e50;
  --border-color: #e0e0e0;
}

body {
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

#app {
  text-align: center;
}

.btn {
  display: inline-block;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  text-align: center;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
}

.btn-secondary {
  background-color: var(--secondary-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
}

.btn-correct {
  background-color: var(--correct-color);
  color: white;
}

.btn-incorrect {
  background-color: var(--incorrect-color);
  color: white;
}

.feedback-correct {
  color: var(--correct-color);
  font-weight: bold;
}

.feedback-incorrect {
  color: var(--incorrect-color);
  font-weight: bold;
}
</style>
